import React from 'react'
import { Checkbox, FormControlLabel, useTheme } from '@mui/material'

const PersistLoginCheckbox = ({ persist, setPersist, bold, sx }) => {
  const theme = useTheme()
  const accent = theme.palette.secondary.main

  return (
    <FormControlLabel
      sx={{
        m: 0,
        '& .MuiFormControlLabel-label': {
          fontSize: '0.85rem',
          fontWeight: bold ? 700 : 400,
          color: theme.palette.text.primary,
        },
        ...sx,
      }}
      control={
        <Checkbox
          id="persist"
          size="small"
          checked={persist}
          onChange={() => setPersist(prev => !prev)}
          sx={{ p: 0.5, mr: 0.75, color: theme.palette.text.secondary, '&.Mui-checked': { color: accent } }}
        />
      }
      label="Keep me logged in"
    />
  )
}

export default PersistLoginCheckbox
